export default __webpack_public_path__ + "static/media/phones.62695897.png";